module.exports = __webpack_public_path__ + "img/shop12de.fcc3fdba.png";